import { useTranslation } from "react-i18next";

const TONE = {
  ok: "bg-emerald-500/15 text-emerald-600",
  warn: "bg-amber-500/15 text-amber-600",
  bad: "bg-destructive/15 text-destructive",
  mute: "bg-muted-foreground/15 text-muted-foreground",
};
const STATE_TONE = {
  draft: "mute", closed: "mute", submitted: "warn", pending_approval: "warn",
  partially_received: "warn", partially_paid: "warn", pending: "warn",
  approved: "ok", sent: "ok", received: "ok", accepted: "ok", matched: "ok", posted: "ok",
  paid: "ok", ordered: "ok", billed: "ok", active: "ok",
  disputed: "bad", rejected: "bad", cancelled: "bad", returned: "bad", archived: "bad",
};

// شريحة حالة ملوّنة (نفس ألوان الثيم).
export const StatusChip = ({ state, labelKey = "purchases.states", testid }) => {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testid || `status-chip-${state}`}
      className={`inline-block whitespace-nowrap rounded-full px-3 py-1 text-[11px] font-bold ${
        TONE[STATE_TONE[state] || "mute"]
      }`}
    >
      {t(`${labelKey}.${state}`, state)}
    </span>
  );
};
